var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFiRrFolderUnarchive = props => {
  const _uid = React.useId().replace(/:/g, '');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#" + _uid + "fi-rr-folder-unarchive_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A56DB",
    fillRule: "evenodd",
    d: "M12 9V4a2.503 2.503 0 0 0-2.5-2.5H6.236a.5.5 0 0 1-.223-.05L4.435.658A1.5 1.5 0 0 0 3.763.5H2.5A2.503 2.503 0 0 0 0 3v6a2.503 2.503 0 0 0 2.5 2.5h7A2.503 2.503 0 0 0 12 9M1 3.5V3a1.5 1.5 0 0 1 1.5-1.5h1.264q.118 0 .224.052l1.578.79c.208.104.437.158.67.158H9.5a1.5 1.5 0 0 1 1.408 1zm10 1V9a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 1 9V4.5zM5.069 6.328c-.16.212-.32.423-.569.672-.5.5.25 1 .5.75l.5-.5V9a.5.5 0 0 0 1 0V7.25l.5.5c.25.25 1-.25.5-.75a8 8 0 0 1-.6-.707c-.18-.23-.356-.456-.546-.647a.5.5 0 0 0-.708 0 6 6 0 0 0-.577.682",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _uid + "fi-rr-folder-unarchive_svg__a"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
export { SvgFiRrFolderUnarchive as ReactComponent };
export default __webpack_public_path__ + "72f27855732de981ef6b927a26eabff5.svg";